import { Vue } from 'vue-property-decorator';

import Validators from '@/config/FormValidators';

import { set as setObj, isNumber } from 'lodash';

import validateIdentificationCode from '@/config/id-lv';

export default class FormValidators extends Vue {
   validatorRequired(value: string, field: any, model: any) {
      return Validators.required(value, { ...field, required: true }, model, {
         fieldIsRequired: this.$t('form.validators.fieldIsRequired'),
      });
   }

   validatorEmail(value: string, field: any, model: any) {
      return Validators.regexp(value, { ...field, pattern: '[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}' }, model, {
         invalidFormat: this.$t('form.validators.invalidEmail'),
      });
   }

   validatorCamera(value: string | null) {
      if (typeof value == 'string' && value.length > 6) {
         return true;
      }
      return [this.$t('form.validators.fieldIsRequired')];
   }

   validatorLicenceId(value: string, field: any, model: any) {
      if (!validateIdentificationCode.isValidIdentificationCode(value)) {
         return [this.$t('form.validators.personal_code')];
      }

      if (value.length === 11 && value.indexOf('-') < 0) {
         value = value.substr(0, 6) + '-' + value.substr(6, 11);
         setObj(model, field.model, value);
      }

      return true;
   }

   validatorCompanyId(value: string, field: any, model: any) {
      const v = parseInt(value);

      if (!isNumber(v) || isNaN(v) || v.toString() !== value) {
         return [this.$t('form.validators.invalidFormat')];
      }

      if (value.length !== 11) {
         return [this.$t('form.validators.registration_code')];
      }

      return true;
   }
}
